<label class="chaicom-checkbox-container" @click="$emit('toggle', clicked)"><input type="checkbox"><span class="chaicom-checkbox-checkmark"></span></label>